/// <amd-module name="Release/Landing/HubMessageBar/MessageStore" />
import * as React from "react";


import { StoreBase } from "DistributedTask/Flux/Store";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { MessageActions, IMessagePayload } from "./MessageActions";

export class MessageStore extends StoreBase {
    public static getKey(): string {
        return "release-landing-message-store";
    }

    public initialize(instanceId?: string): void {
        super.initialize(instanceId);

        this._state = {};
        this._actions = ActionsHubManager.GetActionsHub<MessageActions>(MessageActions);
        this._actions.setMessage.addListener(this._setMessage);
    }

    public disposeInternal(): void {
        this._actions.setMessage.removeListener(this._setMessage);
    }

    public getState(): { [key: string]: React.ReactNode } {
        return this._state;
    }

    private _setMessage = (payload: IMessagePayload): void  => { 
        this._state[payload.key] = payload.value;

        this.emitChanged();
    }

    private _state: { [key: string]: React.ReactNode };
    private _actions: MessageActions;
}
